import { defineMessages } from 'react-intl';

export const skuPayoutReportsMessages = defineMessages({
  listPageTitle: {
    id: 'sku-payout-reports.list.title',
    defaultMessage: 'Payout reports',
  },
  detailPageTitle: {
    id: 'sku-payout-reports.detail.title',
    defaultMessage: 'Payout # {payoutId}',
  },
  listComingSoon: {
    id: 'sku-payout-reports.list.coming-soon',
    defaultMessage: 'Payout reports are coming soon.',
  },
  columnPayoutId: {
    id: 'sku-payout-reports.list.column.payout-id',
    defaultMessage: 'Payout ID',
  },
  columnPayoutPeriod: {
    id: 'sku-payout-reports.list.column.payout-period',
    defaultMessage: 'Payout period',
  },
  columnDatePosted: {
    id: 'sku-payout-reports.list.column.date-posted',
    defaultMessage: 'Date posted',
  },
  columnTotalPayout: {
    id: 'sku-payout-reports.list.column.total-payout',
    defaultMessage: 'Total payout',
  },
  listEmpty: {
    id: 'sku-payout-reports.list.empty',
    defaultMessage: 'No payouts to show yet.',
  },
  listLoadError: {
    id: 'sku-payout-reports.list.load-error',
    defaultMessage: 'We could not load your payouts. Please try again.',
  },
  summaryTotalEarnings: {
    id: 'sku-payout-reports.detail.summary.total-earnings',
    defaultMessage: 'Total earnings',
  },
  summaryTotalPayout: {
    id: 'sku-payout-reports.detail.summary.total-payout',
    defaultMessage: 'Total payout',
  },
  summaryPostedOn: {
    id: 'sku-payout-reports.detail.summary.posted-on',
    defaultMessage: 'Posted on {date}',
  },
  downloadCsv: {
    id: 'sku-payout-reports.detail.download-csv',
    defaultMessage: 'Download CSV',
  },
  downloadCsvComingSoon: {
    id: 'sku-payout-reports.detail.download-csv.coming-soon',
    defaultMessage: 'CSV download is coming soon.',
  },
  downloadCsvGenerating: {
    id: 'sku-payout-reports.detail.download-csv.generating',
    defaultMessage: 'Generating report',
  },
  exportStarted: {
    id: 'sku-payout-reports.detail.export-started',
    defaultMessage: 'Downloading payout report',
  },
  exportFailed: {
    id: 'sku-payout-reports.detail.export-failed',
    defaultMessage: "We couldn't generate the report. Try again in a moment.",
  },
  tableHeaderOrderId: {
    id: 'sku-payout-reports.detail.table.order-id',
    defaultMessage: 'Order ID',
  },
  tableHeaderItems: {
    id: 'sku-payout-reports.detail.table.items',
    defaultMessage: 'Item(s)',
  },
  tableHeaderOrderDateTime: {
    id: 'sku-payout-reports.detail.table.order-date-time',
    defaultMessage: 'Order date & time',
  },
  tableHeaderEffectiveDate: {
    id: 'sku-payout-reports.detail.table.effective-date',
    defaultMessage: 'Effective Date',
  },
  tableHeaderCustomer: {
    id: 'sku-payout-reports.detail.table.customer',
    defaultMessage: 'Customer',
  },
  tableHeaderAmount: {
    id: 'sku-payout-reports.detail.table.amount',
    defaultMessage: 'Amount',
  },
  emptyOrders: {
    id: 'sku-payout-reports.detail.table.empty',
    defaultMessage: 'No orders were included in this payout.',
  },
  detailUnavailable: {
    id: 'sku-payout-reports.detail.unavailable',
    defaultMessage: "Details for this payout aren't available yet. Check back soon.",
  },
  postedOnTooltip: {
    id: 'sku-payout-reports.detail.summary.posted-on.tooltip',
    defaultMessage: 'The date this payout was posted to your bank account.',
  },
});
